import { isNil } from 'lodash-es';
import { LandingPage, Template } from '@dev/ee-api/ee-api-models'
import { LandingPageMetaData } from '@/store/landingPageCreator/types';
import { LandingPageSubdomainModel } from '@/store/landingPageSubdomain/types';

export const getStepsValidity = (isStep3Visible: boolean, landingPageObject: LandingPage, templateObject?: Template, landingPageMetaDataObject?: LandingPageMetaData,landingPageSubdomain?:LandingPageSubdomainModel): Record<number, boolean> => {
    const isStep1Valid = !!landingPageObject?.Name;
    const isStep2Valid = !!templateObject?.EditorMetaData;
    const isStep3Valid = isStep2Valid && (!isStep3Visible || !!landingPageSubdomain?.UrlSuffix);
    const isStep4Valid = isStep3Valid && !isNil(landingPageMetaDataObject?.data?.socialPreview) && !isNil(landingPageObject?.LandingMetaJson);
    const isStep5Valid = isStep1Valid && isStep2Valid && isStep3Valid && isStep4Valid;

    return {
        1: isStep1Valid,
        2: isStep2Valid,
        3: isStep3Valid,
        4: isStep4Valid,
        5: isStep5Valid,
    };
};
